import Saint from './saint';

export default Saint;
